import rambleMarkWhite from "./ramble-mark-white.svg?url"

export default {
  src: rambleMarkWhite,
  width: 250,
  height: 212,
}
